import './LanguageSwitcher.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setLang } from '@/shared/features/langslice';

const languages = ['tr', 'en'];

const LanguageSwitcher = React.memo(() => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation('common');
  const activeLanguage = i18n.language?.toLowerCase().startsWith('en') ? 'en' : 'tr';

  const onLanguageChange = (language) => {
    dispatch(setLang(language));
    i18n.changeLanguage(language);
  };

  return (
    <div className="c-language-switcher" role="group" aria-label={t('common.languages.select')}>
      {languages.map((language) => (
        <button
          key={language}
          type="button"
          aria-pressed={activeLanguage === language}
          className={`c-language-switcher__option ${
            activeLanguage === language ? 'c-language-switcher__option--active' : ''
          }`}
          onClick={() => onLanguageChange(language)}
        >
          {language.toUpperCase()}
        </button>
      ))}
    </div>
  );
});

LanguageSwitcher.displayName = 'LanguageSwitcher';
export { LanguageSwitcher };
